<div [ngClass]="isBoxShadow() ? 'is-box-shadow' : ''" class="profile-picture-wrap rounded-lg" [style.width]="imageSize()" [style.height]="imageSize()">
    @if (imageUrl() === undefined) {
        <strong
            [id]="defaultPictureId()"
            class="profile-picture rounded-lg"
            [style.background-color]="isGray() ? undefined : profilePictureBackgroundColor()"
            [style.font-size]="fontSize()"
            [ngClass]="defaultPictureClass() + (isGray() ? ' is-grayscale' : '')"
            >{{ userProfilePictureInitials() }}</strong
        >
    } @else {
        <img
            [id]="imageId()"
            [alt]="authorName()"
            class="profile-picture rounded-lg"
            [ngSrc]="imageUrl()!"
            fill
            [style.background-color]="imageBackgroundColor() ?? profilePictureBackgroundColor()"
            [ngClass]="imageClass() + (isGray() ? ' is-grayscale' : '')"
        />
    }
    @if (isEditable()) {
        <a class="edit-profile-picture-overlay rounded-lg flex items-center justify-center" [routerLink]="['/user-settings']" routerLinkActive="active">
            <fa-icon class="text-white" [icon]="faCog" />
        </a>
    }
</div>
